module.exports = __webpack_public_path__ + "static/thatconfheader-7f317790e0a7b83b15cb4835e3aaf023.jpeg";